export const AFFILIATE_MARKETING_EVENT_TRIGGER_CALL = 'AFFILIATE_MARKETING_EVENT_TRIGGER_CALL';
export const AFFILIATE_MARKETING_EVENT_TRIGGER_DONE = 'AFFILIATE_MARKETING_EVENT_TRIGGER_DONE';
export const AFFILIATE_MARKETING_EVENT_TRIGGER_FAIL = 'AFFILIATE_MARKETING_EVENT_TRIGGER_FAIL';
